<template>
    <div>
        <slot v-if="key == 'list'" name="list"></slot>
        <slot v-if="key == 'card'" name="card"></slot>
    </div>
</template>
<style scoped>
</style>
<script>
    export default {
        name: 'switchLayout',
        props: {
            storageKey: String,
        },
        data: () => ({
            key: "list"
        }),
        created: function () {
            $App.event.$on("app_switchLayout", this.onSwitchLayout);
        },
        destroyed: function () {
            $App.event.$off("app_switchLayout", this.onSwitchLayout);
        },
        mounted:
            async function () {
                let key = localStorage.getItem(this.storageKey);
                if(key){ this.key = key; }
                $App.event.$emit("app_switchLayout", this.key );
            },

        methods: {
            onSwitchLayout: function (e) {
                if(e){
                    this.key = e;
                    localStorage.setItem(this.storageKey, this.key);
                }
            }
        }
    }
</script>